import { render, staticRenderFns } from "./player-error.vue?vue&type=template&id=96033432&scoped=true&"
import script from "./player-error.vue?vue&type=script&lang=ts&"
export * from "./player-error.vue?vue&type=script&lang=ts&"
import style0 from "./player-error.vue?vue&type=style&index=0&id=96033432&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96033432",
  null
  
)

export default component.exports